export const cardStyles = {
    marginTop: 20,
};